const CRISP_WEBSITE_ID = "f7a34873-07fc-45ca-8d85-c9a202384775";
const CRISP_SCRIPT_SRC = "https://client.crisp.chat/l.js";

const pushCrispSessionData = () => {
  window.$crisp.push([
    "set",
    "session:data",
    [
      [
        ["source", "useservd.com"],
        ["surface", "marketing_site"],
        ["page_path", window.location.pathname],
      ],
    ],
  ]);
  window.$crisp.push(["set", "session:segments", [["marketing-site"]]]);
};

export const onClientEntry = () => {
  window.$crisp = window.$crisp || [];
  window.CRISP_WEBSITE_ID = window.CRISP_WEBSITE_ID || CRISP_WEBSITE_ID;

  pushCrispSessionData();

  if (document.querySelector(`script[src="${CRISP_SCRIPT_SRC}"]`)) {
    return;
  }

  const script = document.createElement("script");
  script.src = CRISP_SCRIPT_SRC;
  script.async = true;
  document.head.appendChild(script);
};

export const onRouteUpdate = () => {
  if (!window.$crisp) {
    return;
  }

  pushCrispSessionData();
};
